import { DirectivesModule } from '@/app/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CanvasJSAngularChartsModule } from '@canvasjs/angular-charts';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxEchartsModule } from 'ngx-echarts';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { AutoCompleteModule } from 'primeng/autocomplete';
//! TODO Migrated from v18 @primeng
import { DatePickerModule } from 'primeng/datepicker';
// import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
//! TODO Migrated from v18 @primeng
import { SelectModule } from 'primeng/select';
// import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { ImageModule } from 'primeng/image';
//! TODO Migrated from v20 @primeng
import { ToggleSwitchModule } from 'primeng/toggleswitch';
// import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { PipesModule } from '../core/pipes/pipes.module';
import { AddButtonComponent } from './add-button/add-button.component';
import { ButtonAnimatedComponent } from './sidebar/button-animated/button-animated.component';
import { ItemComponent } from './sidebar/item/item.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ItemNotificationComponent } from './notifications/item-notification/item-notification.component';
import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { ButtonAddGlobalComponent } from './button-add/button-add.component';
import { ButtonComponent } from './button/button.component';
import { CalendarComponent } from './calendar/calendar.component';
import { CardInstructivoComponent } from './card-instructivo/card-instructivo.component';
import { ChartComponent } from './chart/chart.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { CierreCardComponent } from './cierre-card/cierre-card.component';
import { CollapseComponent } from './collapse/collapse.component';
import { CookiesComponent } from './cookies/cookies.component';
import { CropImageComponent } from './crop-image/crop-image.component';
import { CursoComponent } from './curso/curso.component';
import { DescargoCardComponent } from './descargo-card/descargo-card.component';
import { DialogComponent } from './dialog/dialog.component';
import { DoughnutchartComponent } from './doughnutchart/doughnutchart.component';
import { DropdownComponent } from './dropdown/dropdown.component';
import { EdicionesComponent } from './ediciones/ediciones.component';
import { PdfViewerComponent } from './files/components/pdf-viewer/pdf-viewer.component';
import { FilesComponent } from './files/files.component';
import { ImportExcelComponent } from './import-excel/import-excel.component';
import { InputComponent } from './input/input.component';
import { ListboxComponent } from './listbox/listbox.component';
import { MultiCheckboxItemComponent } from './multi-checkbox/multi-checkbox-item/multi-checkbox-item.component';
import { MultiCheckboxComponent } from './multi-checkbox/multi-checkbox.component';
import { MultiItemComponent } from './multi-selector/multi-item/multi-item.component';
import { MultiSelectorComponent } from './multi-selector/multi-selector.component';
import { PiechartComponent } from './piechart/piechart.component';
import { RadioGroupComponent } from './radio-group/radio-group.component';
import { ModalAdjuntosComponent } from './resources/components/modal-adjuntos/modal-adjuntos.component';
import { ModalRepoComponent } from './resources/components/modal-adjuntos/modal-repo/modal-repo.component';
import { ResFilesComponent } from './resources/components/modal-adjuntos/res-files/res-files.component';
import { ModalVideosComponent } from './resources/components/modal-videos/modal-videos.component';
import { PetrolBadgeComponent } from './petrol-ng/badge/badge.component';
import { PetrolButtonComponent } from './petrol-ng/button/button.component';
import { PetrolIconButtonComponent } from './petrol-ng/icon-button/icon-button.component';
import { PetrolDrawerComponent } from './petrol-ng/drawer/drawer.component';
import { InstructivosPanelComponent } from './instructivos-panel/instructivos-panel.component';
import { ResourcesComponent } from './resources/resources.component';
import { RouterButtonComponent } from './router-button/router-button.component';
import { FooterComponent } from './footer/footer.component';
import { ScrollProgressComponent } from './scroll-progress/scroll-progress.component';
import { SpellCheckerComponent } from './spell-checker/spell-checker.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { FilterComponent } from './table/filter/filter.component';
import { TableComponent } from './table/table.component';
import { TextareaComponent } from './textarea/textarea.component';
import { TabsComponent } from './tabs/tabs.component';
import { TabComponent } from './tabs/tab/tab.component';
import { ButtonLoadingComponent } from './button-loading/button-loading.component';
import { CardItemComponent } from './card-item/card-item.component';
import { UserPanelComponent } from './user-panel/user-panel.component';
import { AvatarModule } from 'primeng/avatar';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { CheckedThemeComponent } from './checked-theme/checked-theme.component';
import { ToggleComponent } from './toggle/toggle.component';
import { UserSessionComponent } from './user-session/user-session.component';
import { SessionModalComponent } from './user-session/components/session-modal/session-modal.component';
import { VerifyTwofaComponent } from './verify-twofa/verify-twofa.component';

const declarations = [
  AddButtonComponent,
  AutocompleteComponent,
  ButtonAddGlobalComponent,
  ButtonComponent,
  CalendarComponent,
  CardInstructivoComponent,
  InstructivosPanelComponent,
  ChartComponent,
  CheckboxComponent,
  CierreCardComponent,
  CollapseComponent,
  CookiesComponent,
  CropImageComponent,
  CursoComponent,
  DescargoCardComponent,
  DialogComponent,
  DoughnutchartComponent,
  DropdownComponent,
  EdicionesComponent,
  FilesComponent,
  FilterComponent,
  ImportExcelComponent,
  InputComponent,
  ListboxComponent,
  ModalAdjuntosComponent,
  ModalRepoComponent,
  ModalVideosComponent,
  MultiCheckboxComponent,
  MultiCheckboxItemComponent,
  MultiItemComponent,
  MultiSelectorComponent,
  PdfViewerComponent,
  PiechartComponent,
  RadioGroupComponent,
  ResFilesComponent,
  ResourcesComponent,
  RouterButtonComponent,
  ScrollProgressComponent,
  SpellCheckerComponent,
  SpinnerComponent,
  TabComponent,
  TableComponent,
  TabsComponent,
  TextareaComponent,
  ButtonLoadingComponent,
  CardItemComponent,
  UserPanelComponent,
  NavbarComponent,
  SidebarComponent,
  ItemComponent,
  ButtonAnimatedComponent,
  NotificationsComponent,
  ItemNotificationComponent,
  FooterComponent,
  CheckedThemeComponent,
  ToggleComponent,
  UserSessionComponent,
  SessionModalComponent,
  VerifyTwofaComponent,
];

@NgModule({
  declarations,
  imports: [
    RouterModule,
    NgxEchartsModule.forRoot({
      /**
       * This will import all modules from echarts.
       * If you only need custom modules,
       * please refer to [Custom Build] section.
       */
      echarts: () => import('echarts'), // or import('./path-to-my-custom-echarts')
    }),
    FormsModule,
    CommonModule,
    InputTextModule,
    //! TODO Migrated from v18 @primeng
    // DropdownModule,
    SelectModule,
    AutoCompleteModule,
    RippleModule,
    ConfirmDialogModule,
    ToastModule,
    TooltipModule,
    ImageModule,
    //! TODO Migrated from v18 @primeng
    // CalendarModule,
    DatePickerModule,
    TableModule,
    PaginatorModule,
    DialogModule,
    EditorModule,
    ImageCropperComponent,
    DirectivesModule,
    MultiSelectModule,
    PipesModule,
    //! TODO Migrated from v20 @primeng
    // InputSwitchModule,
    ToggleSwitchModule,
    ListboxModule,
    CanvasJSAngularChartsModule,
    TimelineModule,
    PdfViewerModule,
    AvatarModule,
    PetrolButtonComponent,
    PetrolIconButtonComponent,
    PetrolBadgeComponent,
    PetrolDrawerComponent,
    ToggleButtonModule,
  ],
  exports: [
    InputComponent,
    DropdownComponent,
    AutocompleteComponent,
    ButtonComponent,
    CollapseComponent,
    DialogComponent,
    SpinnerComponent,
    ChartComponent,
    RouterButtonComponent,
    FilesComponent,
    CalendarComponent,
    CheckboxComponent,
    TextareaComponent,
    TableComponent,
    ResourcesComponent,
    AddButtonComponent,
    EdicionesComponent,
    MultiSelectorComponent,
    CropImageComponent,
    RadioGroupComponent,
    MultiCheckboxComponent,
    ButtonAddGlobalComponent,
    ScrollProgressComponent,
    CursoComponent,
    CookiesComponent,
    ImportExcelComponent,
    SpellCheckerComponent,
    DescargoCardComponent,
    CardInstructivoComponent,
    InstructivosPanelComponent,
    ListboxComponent,
    CierreCardComponent,
    PiechartComponent,
    DoughnutchartComponent,
    TabsComponent,
    TabComponent,
    ButtonLoadingComponent,
    CardItemComponent,
    PetrolButtonComponent,
    PetrolIconButtonComponent,
    PetrolBadgeComponent,
    NavbarComponent,
    SidebarComponent,
    ItemComponent,
    ButtonAnimatedComponent,
    NotificationsComponent,
    ItemNotificationComponent,
    FooterComponent,
    CheckedThemeComponent,
    ToggleComponent,
  ],
})
export class SharedModule {}
